import HTTPClient from "./http-client";
import { LOCAL_STORAGE_ACCESS_TOKEN } from "@/helpers/local_storage_constants";
import UserlogService from "@/api/rest-administrative/userlog.service";

// - It works in curl with special characters!
// $ curl -X POST -d 'grant_type=password&username=teste.novo@copel.com&password=^A1s2d3f4&client_id=clientOIDC&client_secret=secretOIDC' -H "Content-Type: application/x-www-form-urlencoded" https://auth2.simepar.br/cas/oauth2.0/accessToken
// Response: {"access_token":"TOKEN","token_type":"bearer","expires_in":43200,"scope":""}
// - Password with '&' -> use url encode!
// $ curl -X POST -d 'grant_type=password&username=teste.novo@copel.com&password=%26A1s2d3f4&client_id=clientOIDC&client_secret=secretOIDC' -H "Content-Type: application/x-www-form-urlencoded" https://auth2.simepar.br/cas/oauth2.0/accessToken
class AuthService {
    async login(username, password) {
        const httpClient = new HTTPClient();
        const api = await httpClient.configure();

        const client_id = `${process.env.VUE_APP_API_CLIENT_ID}`;
        const client_secret = `${process.env.VUE_APP_API_CLIENT_SECRET}`;

        const headerData = {
            'Content-Type': 'application/x-www-form-urlencoded',
        };

        const params = "grant_type=password"+
            "&username=" + username +
            "&password=" + encodeURIComponent(password) +
            "&client_id=" + client_id +
            "&client_secret=" + client_secret;

        return api
            .post(`${process.env.VUE_APP_API_CAS_TOKEN}`, params, {
                headers: headerData
            })
            .then(response => {
                if (response.data.access_token) {
                    localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, response.data.access_token);
                }

                // Register access
                var register = async function() {
                    try {
                        await UserlogService.registerAccess();
                    }
                    catch(error) {
                        console.error("Falha ao registrar acesso!");
                    }
                };
                register();

                return response.data;
            })
            .catch((error) => {
                console.log("error: ", error)
            });
    }

    // curl -X GET https://auth2.simepar.br/cas/oauth2.0/profile?access_token=TOKEN
    async profile(token) {
        const httpClient = new HTTPClient();
        const api = await httpClient.configure();

        return api
            .get(`${process.env.VUE_APP_API_CAS_PROFILE}?access_token=${token}`)
            .then(response => {
                return response.data;
            });
    }

    logout() {
      localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    }

  }

  export default new AuthService();